var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocumentGary4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 7.49982C3.47018 7.49982 3.75 7.77964 3.75 8.12482V14.7915C3.75 16.2873 4.96256 17.4998 6.45833 17.4998H11.4583C11.8035 17.4998 12.0833 17.7796 12.0833 18.1248C12.0833 18.47 11.8035 18.7498 11.4583 18.7498H6.45833C4.27221 18.7498 2.5 16.9776 2.5 14.7915V8.12482C2.5 7.77964 2.77982 7.49982 3.125 7.49982Z",
    fill: "#4A5256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29167 2.5C6.71637 2.5 6.25 2.96637 6.25 3.54167V13.9582C6.25 14.5335 6.71637 14.9998 7.29167 14.9998H14.9166C15.4919 14.9998 15.9583 14.5335 15.9583 13.9582V7.43743C15.9583 7.38388 15.9376 7.33239 15.9007 7.29364L11.3905 2.56455C11.3512 2.52333 11.2967 2.5 11.2397 2.5H7.29167ZM5 3.54167C5 2.27601 6.02601 1.25 7.29167 1.25H11.2397C11.6385 1.25 12.0198 1.41329 12.2951 1.70185L16.8053 6.43094C17.0639 6.70218 17.2083 7.06261 17.2083 7.43743V13.9582C17.2083 15.2238 16.1822 16.2498 14.9166 16.2498H7.29167C6.02601 16.2498 5 15.2238 5 13.9582V3.54167Z",
    fill: "#4A5256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5833 1.25C11.9284 1.25 12.2083 1.52982 12.2083 1.875V6.47013C12.2083 6.58542 12.3019 6.67879 12.4172 6.67847L16.5815 6.66667C16.9267 6.66569 17.2073 6.94472 17.2082 7.2899C17.2092 7.63507 16.9302 7.91569 16.585 7.91666L12.4207 7.92846C11.6137 7.93075 10.9583 7.27716 10.9583 6.47013V1.875C10.9583 1.52982 11.2381 1.25 11.5833 1.25Z",
    fill: "#4A5256"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentGary4);
export default __webpack_public_path__ + "static/media/icon-document-gary4.bc4f36b4a4073ff19fcbe1657bfa8485.svg";
export { ForwardRef as ReactComponent };